@use '../../globals/mixins';
@use '../../../node_modules/@symplr-ux/alloy-theme/dist/scss/1-tools' as tools;

.sympl-footer {
  @include mixins.symplr-tools-theme-element() using ($theme-name) {
    background-color: mixins.symplr-tools-get-semantic-slot('body.background', $theme-name);

    /* Footer needs unique positioning, variables not applicable in most cases */
    .footer-container {
      @include tools.body2();
      color: mixins.symplr-tools-get-semantic-slot('input.text', $theme-name);
      padding: 10px 56px 6px 30px;

      .image {
        width: 64px;
        padding-top: 2px;
      }

      .link {
        padding-top: tools.get-spacing('xxs') * 0.5;
        text-align: center;
      }

      .sympl-action-link {
        color: mixins.symplr-tools-get-semantic-slot('body.text', $theme-name);
      }

      .c-right {
        float: right;
        font-size: mixins.symplr-tools-get-font-size('sm');
        padding-top: 6px;

        .copyright { /* stylelint-disable-line */
          padding-left: 16px;
        }
      }
    }
  }
}
